export const useModeration = createGlobalState(() => {
  const userModerationState = reactive<
    Record<
      number,
      {
        isMuted?: boolean
        isKicked?: boolean
      }
    >
  >({})

  const isMuted = (userId: number) =>
    userModerationState[userId]?.isMuted ?? false
  const isKicked = (userId: number) =>
    userModerationState[userId]?.isKicked ?? false

  const setMuted = (userId: number, value: boolean) => {
    userModerationState[userId] ??= {}
    userModerationState[userId].isMuted = value
  }
  const setKicked = (userId: number, value: boolean) => {
    userModerationState[userId] ??= {}
    userModerationState[userId].isKicked = value
  }

  return {
    getMuted: isMuted,
    getKicked: isKicked,
    setMuted,
    setKicked,
  }
})
